<template>
  <div class="plan-downgrade">
    <div class="plan-title">
      <RouterLink to="/settings/payment/plans" class="plan-title__link">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="black" />
        </svg>
      </RouterLink>
      {{ $t('changePlan') }}
    </div>
    <Preloader v-if="localLoading" />
    <div v-show="!localLoading" v-if="plan">
      <div class="plan-subtitle">
        {{ $t('subject',{ nextPlan: plan.title }) }}
      </div>
      <VBtn @click="downgrade">
        {{ $t('confirm') }}
      </VBtn>
    </div>
  </div>
</template>

<script>
import useValidation from '@/compositions/useValidation';
import Preloader from '@/components/Preloader';
import useSubscription from '@/compositions/accounting/useSubscription';

export default {
  name: 'PlanRenewOnDefault',

  components: {
    Preloader,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { withLoading, localLoading } = useValidation();

    const { renewSubscriptionOnDefaultPlan } = useSubscription();

    function downgrade() {
      withLoading(async () => {
        await renewSubscriptionOnDefaultPlan();
      });
    }

    return {
      downgrade,
      localLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-downgrade {
  font-weight: 400;
  padding: 2.125rem 2.5rem;
}
.plan-title {
  font-size: 1.5rem;
  line-height: 1.2;
  color: #212121;
  margin-bottom: 1rem;
  &__link {
    display: inline-block;
    height: 1.5rem;
    vertical-align: middle;
    margin-right: 0.25rem;
  }
}
.plan-subtitle {
  font-size: 1.0625rem;
  line-height: 1.53;
  color: #091A35;
  margin-bottom: 1rem;
}

</style>

<i18n lang="yml" locale="ru">
changePlan: Изменение тарифного плана
subject: 'Вы переходите на бесплатный тарифный план «{nextPlan}».'
confirm: 'Подтвердить'
</i18n>
<i18n lang="yml" locale="en">
changePlan: Change plan
subject: 'You are now switching to free plan “{nextPlan}”.'
confirm: 'Confirm'
</i18n>


